import type { JSX } from "solid-js";
import { Show } from "solid-js";
import { DECORATIVE_IMAGE_ALT } from "../../constants";
import type { ImageOption } from "../../types/Menu";
import { LocalImage, RemoteImage } from "../image/Image";

type SelectImageProps = {
  size: "sm" | "md";
} & ImageOption<null>["image"];

const SelectImage = (props: SelectImageProps): JSX.Element => (
  <div
    class="shrink-0"
    classList={{ "size-6": props.size === "sm", "size-11 rounded-sm border border-subtle": props.size === "md" }}
  >
    <Show when={props.src}>
      {(src) => <LocalImage alt={DECORATIVE_IMAGE_ALT} src={src()} cover={false} size="custom" />}
    </Show>
    <Show when={props.resourceId}>
      {(resourceId) => <RemoteImage alt={DECORATIVE_IMAGE_ALT} resourceId={resourceId()} cover={false} size="custom" />}
    </Show>
  </div>
);

export default SelectImage;
